var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 186 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 60H18C14.64 60 12 57.36 12 54V18C12 14.64 14.64 12 18 12H168C171.36 12 174 14.64 174 18V54C174 57.24 171.36 60 168 60Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168 12.96C170.76 12.96 173.04 15.24 173.04 18V54C173.04 56.76 170.76 59.04 168 59.04H18C15.24 59.04 12.96 56.76 12.96 54V18C12.96 15.24 15.24 12.96 18 12.96H168ZM168 12H18C14.64 12 12 14.64 12 18V54C12 57.36 14.64 60 18 60H168C171.36 60 174 57.36 174 54V18C174 14.76 171.36 12 168 12Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.7203 38.1595C90.8403 38.1595 88.5603 40.3195 88.5603 43.3195C88.5603 46.1995 90.8403 48.4795 93.7203 48.4795C96.6003 48.4795 98.8803 46.3195 98.8803 43.3195C98.8803 40.1995 96.6003 38.1595 93.7203 38.1595ZM93.7203 46.3195C92.1603 46.3195 90.8403 44.9995 90.8403 43.1995C90.8403 41.3995 92.1603 40.0795 93.7203 40.0795C95.2803 40.0795 96.6003 41.2795 96.6003 43.1995C96.6003 44.9995 95.2803 46.3195 93.7203 46.3195ZM82.5603 38.1595C79.6803 38.1595 77.4003 40.3195 77.4003 43.3195C77.4003 46.1995 79.6803 48.4795 82.5603 48.4795C85.4403 48.4795 87.7203 46.3195 87.7203 43.3195C87.7203 40.1995 85.4403 38.1595 82.5603 38.1595ZM82.5603 46.3195C81.0003 46.3195 79.6803 44.9995 79.6803 43.1995C79.6803 41.3995 81.0003 40.0795 82.5603 40.0795C84.1203 40.0795 85.4403 41.2795 85.4403 43.1995C85.4403 44.9995 84.1203 46.3195 82.5603 46.3195ZM69.2403 39.7195V41.8795H74.4003C74.2803 43.0795 73.8003 44.0395 73.2003 44.6395C72.4803 45.3595 71.2803 46.1995 69.2403 46.1995C66.0003 46.1995 63.6003 43.6795 63.6003 40.4395C63.6003 37.1995 66.1203 34.6795 69.2403 34.6795C70.9203 34.6795 72.2403 35.3995 73.2003 36.2395L74.7603 34.6795C73.4403 33.4795 71.7603 32.5195 69.3603 32.5195C65.0403 32.5195 61.3203 36.1195 61.3203 40.4395C61.3203 44.7595 65.0403 48.3595 69.3603 48.3595C71.7603 48.3595 73.4403 47.6395 74.8803 46.0795C76.3203 44.6395 76.8003 42.5995 76.8003 41.0395C76.8003 40.5595 76.8003 40.0795 76.6803 39.7195H69.2403ZM123.72 41.3995C123.24 40.1995 122.04 38.1595 119.4 38.1595C116.76 38.1595 114.6 40.1995 114.6 43.3195C114.6 46.1995 116.76 48.4795 119.64 48.4795C121.92 48.4795 123.36 47.0395 123.84 46.1995L122.16 44.9995C121.56 45.8395 120.84 46.4395 119.64 46.4395C118.44 46.4395 117.72 45.9595 117.12 44.8795L123.96 41.9995L123.72 41.3995ZM116.76 43.0795C116.76 41.1595 118.32 40.0795 119.4 40.0795C120.24 40.0795 121.08 40.5595 121.32 41.1595L116.76 43.0795ZM111.12 47.9995H113.4V32.9995H111.12V47.9995ZM107.52 39.2395C106.92 38.6395 105.96 38.0395 104.76 38.0395C102.24 38.0395 99.8403 40.3195 99.8403 43.1995C99.8403 46.0795 102.12 48.2395 104.76 48.2395C105.96 48.2395 106.92 47.6395 107.4 47.0395H107.52V47.7595C107.52 49.6795 106.44 50.7595 104.76 50.7595C103.44 50.7595 102.48 49.7995 102.24 48.9595L100.32 49.7995C100.92 51.1195 102.36 52.7995 104.88 52.7995C107.52 52.7995 109.68 51.2395 109.68 47.5195V38.3995H107.52V39.2395ZM104.88 46.3195C103.32 46.3195 102 44.9995 102 43.1995C102 41.3995 103.32 40.0795 104.88 40.0795C106.44 40.0795 107.64 41.3995 107.64 43.1995C107.64 44.9995 106.44 46.3195 104.88 46.3195ZM134.16 32.9995H128.76V47.9995H131.04V42.3595H134.16C136.68 42.3595 139.08 40.5595 139.08 37.6795C139.08 34.7995 136.68 32.9995 134.16 32.9995ZM134.28 40.1995H131.04V35.0395H134.28C135.96 35.0395 136.92 36.4795 136.92 37.5595C136.8 38.8795 135.84 40.1995 134.28 40.1995ZM148.08 38.0395C146.4 38.0395 144.72 38.7595 144.12 40.3195L146.16 41.1595C146.64 40.3195 147.36 40.0795 148.2 40.0795C149.4 40.0795 150.48 40.7995 150.6 41.9995V42.1195C150.24 41.8795 149.28 41.5195 148.32 41.5195C146.16 41.5195 144 42.7195 144 44.8795C144 46.9195 145.8 48.2395 147.72 48.2395C149.28 48.2395 150 47.5195 150.6 46.7995H150.72V47.9995H152.88V42.2395C152.64 39.5995 150.6 38.0395 148.08 38.0395ZM147.84 46.3195C147.12 46.3195 146.04 45.9595 146.04 44.9995C146.04 43.7995 147.36 43.4395 148.44 43.4395C149.4 43.4395 149.88 43.6795 150.48 43.9195C150.24 45.3595 149.04 46.3195 147.84 46.3195ZM160.44 38.3995L157.92 44.8795H157.8L155.16 38.3995H152.76L156.72 47.5195L154.44 52.5595H156.72L162.84 38.3995H160.44ZM140.28 47.9995H142.56V32.9995H140.28V47.9995Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8797 24.2403C68.8797 25.2003 68.6397 26.0403 68.0397 26.6403C67.3197 27.3603 66.4797 27.7203 65.3997 27.7203C64.3197 27.7203 63.4797 27.3603 62.7597 26.6403C62.0397 25.9203 61.6797 25.0803 61.6797 24.0003C61.6797 22.9203 62.0397 22.0803 62.7597 21.3603C63.4797 20.6403 64.3197 20.2803 65.3997 20.2803C65.8797 20.2803 66.3597 20.4003 66.8397 20.6403C67.3197 20.8803 67.6797 21.1203 67.9197 21.4803L67.3197 22.0803C66.8397 21.4803 66.2397 21.2403 65.3997 21.2403C64.6797 21.2403 63.9597 21.4803 63.4797 22.0803C62.8797 22.5603 62.6397 23.2803 62.6397 24.1203C62.6397 24.9603 62.8797 25.6803 63.4797 26.1603C64.0797 26.6403 64.6797 27.0003 65.3997 27.0003C66.2397 27.0003 66.8397 26.7603 67.4397 26.1603C67.7997 25.8003 68.0397 25.3203 68.0397 24.7203H65.3997V23.8803H68.8797C68.8797 23.8803 68.8797 24.1203 68.8797 24.2403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3992 21.2404H71.1592V23.5204H74.1592V24.3604H71.1592V26.6404H74.3992V27.6004H70.1992V20.4004H74.3992V21.2404Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3594 27.6004H77.3994V21.2404H75.3594V20.4004H80.3994V21.2404H78.3594V27.6004Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8789 27.6004V20.4004H84.8389V27.6004H83.8789Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.918 27.6004H87.958V21.2404H85.918V20.4004H90.838V21.2404H88.798V27.6004H88.918Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.321 26.6403C99.6009 27.3603 98.7609 27.7203 97.6809 27.7203C96.6009 27.7203 95.7609 27.3603 95.0409 26.6403C94.3209 25.9203 93.9609 25.0803 93.9609 24.0003C93.9609 22.9203 94.3209 22.0803 95.0409 21.3603C95.7609 20.6403 96.6009 20.2803 97.6809 20.2803C98.7609 20.2803 99.6009 20.6403 100.321 21.3603C101.041 22.0803 101.401 22.9203 101.401 24.0003C101.401 25.0803 101.041 25.9203 100.321 26.6403ZM95.7609 26.0403C96.2409 26.5203 96.9609 26.8803 97.6809 26.8803C98.4009 26.8803 99.1209 26.6403 99.6009 26.0403C100.081 25.5603 100.441 24.8403 100.441 24.0003C100.441 23.1603 100.201 22.4403 99.6009 21.9603C99.1209 21.4803 98.4009 21.1203 97.6809 21.1203C96.9609 21.1203 96.2409 21.3603 95.7609 21.9603C95.2809 22.4403 94.9209 23.1603 94.9209 24.0003C94.9209 24.8403 95.1609 25.5603 95.7609 26.0403Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.719 27.6004V20.4004H103.799L107.279 26.0404V24.6004V20.4004H108.239V27.6004H107.279L103.559 21.7204V23.1604V27.6004H102.719Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4789 21C24.1189 21.36 23.8789 21.96 23.8789 22.68V49.2C23.8789 49.92 24.1189 50.52 24.4789 50.88L24.5989 51L39.4789 36.12V36V35.88L24.4789 21Z",
    fill: "url(#paint0_linear_3884_25586)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4005 41.1609L39.4805 36.2409V36.0009V35.8809L44.4005 30.9609L44.5205 31.0809L50.4005 34.4409C52.0805 35.4009 52.0805 36.9609 50.4005 37.9209L44.4005 41.1609Z",
    fill: "url(#paint1_linear_3884_25586)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5205 41.04L39.4805 36L24.4805 51C25.0805 51.6 25.9205 51.6 27.0005 51.12L44.5205 41.04Z",
    fill: "url(#paint2_linear_3884_25586)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5205 30.9609L27.0005 21.0009C25.9205 20.4009 25.0805 20.5209 24.4805 21.1209L39.4805 36.0009L44.5205 30.9609Z",
    fill: "url(#paint3_linear_3884_25586)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M44.4005 40.9209L27.0005 50.7609C26.0405 51.3609 25.2005 51.2409 24.6005 50.7609L24.4805 50.8809L24.6005 51.0009C25.2005 51.4809 26.0405 51.6009 27.0005 51.0009L44.4005 40.9209Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M24.48 50.7611C24.12 50.4011 24 49.8011 24 49.0811V49.2011C24 49.9211 24.24 50.5211 24.6 50.8811V50.7611H24.48Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M50.3984 37.56L44.3984 40.92L44.5184 41.04L50.3984 37.68C51.2384 37.2 51.5984 36.6 51.5984 36C51.5984 36.6 51.1184 37.08 50.3984 37.56Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M27 21.1204L50.4 34.4404C51.12 34.9204 51.6 35.4004 51.6 36.0004C51.6 35.4004 51.24 34.8004 50.4 34.3204L27 21.0004C25.32 20.0404 24 20.8804 24 22.8004V22.9204C24 21.0004 25.32 20.1604 27 21.1204Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3884_25586",
    x1: 38.1585,
    y1: 22.4516,
    x2: 18.0197,
    y2: 42.5905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3884_25586",
    x1: 52.6017,
    y1: 36.0026,
    x2: 23.5655,
    y2: 36.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3884_25586",
    x1: 41.7929,
    y1: 38.7553,
    x2: 14.4829,
    y2: 66.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3884_25586",
    x1: 20.7572,
    y1: 12.2124,
    x2: 32.9523,
    y2: 24.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadge);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default MemoForwardRef;